import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';
import ActionDelete from '@material-ui/icons/Delete';
import classnames from 'classnames';
import { translate, crudDelete, startUndoable } from 'ra-core';
import IconCancel from '@material-ui/icons/Cancel';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

import { Button } from 'react-admin';

const styles = (theme) => ({
    deleteButton: {
        color: theme.palette.error.main,
        '&:hover': {
            backgroundColor: fade(theme.palette.error.main, 0.12),
            // Reset on mouse devices
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }
});

class DeleteButtonWithConfirmation extends Component {
    state = {
        showDialog: false
    };

    handleClick = () => {
        this.setState({ showDialog: true })
    };

    handleCloseClick = () => {
        this.setState({ showDialog: false });
    };

    handleDelete = (event) => {
        event.preventDefault();
        this.setState({ showDialog: false });
        const { dispatchCrudDelete, startUndoable, selectedIds, record, resource, basePath, redirect, undoable } = this.props;
        if (undoable) {

            selectedIds.forEach(recordId => {
                startUndoable(crudDelete(resource, recordId, record, basePath, redirect));
            });

        } else {
            dispatchCrudDelete(resource, record.id, record, basePath, redirect);
        }
    };

    render() {
        const { showDialog } = this.state;
        const { label = 'ra.action.delete', classes = {}, textConfirm, subTextConfirm, className } = this.props;
        return (
            <Fragment>
                <Button onClick={this.handleClick} label={label} className={classnames('ra-delete-button', classes.deleteButton, className)} key="button">
                    <ActionDelete />
                </Button>
                <Dialog fullWidth open={showDialog} onClose={this.handleCloseClick} aria-label="Are you sure?">
                    <DialogTitle>{textConfirm}</DialogTitle>
                    <DialogContent>
                        <div>
                            {subTextConfirm}
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button label="CANCEL" onClick={this.handleCloseClick}>
                            <IconCancel />
                        </Button>
                        <Button onClick={this.handleDelete} label='CONFIRM' className={classnames('ra-delete-button', classes.deleteButton, className)} key="button">
                            <ActionDelete />
                        </Button>
                    </DialogActions>
                </Dialog>
            </Fragment>
        );
    }
}

DeleteButtonWithConfirmation.propTypes = {
    basePath: PropTypes.string,
    classes: PropTypes.object,
    textConfirm: PropTypes.string,
    subTextConfirm: PropTypes.string,
    className: PropTypes.string,
    dispatchCrudDelete: PropTypes.func.isRequired,
    label: PropTypes.string,
    record: PropTypes.object,
    redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.func]),
    resource: PropTypes.string.isRequired,
    startUndoable: PropTypes.func,
    translate: PropTypes.func,
    undoable: PropTypes.bool
};

DeleteButtonWithConfirmation.defaultProps = {
    redirect: 'list',
    textConfirm: 'Вы уверены, что хотите удалить?',
    subTextConfirm: '',
    undoable: true
};

export default compose(
    connect(
        null,
        { startUndoable, dispatchCrudDelete: crudDelete }
    ),
    translate,
    withStyles(styles)
)(DeleteButtonWithConfirmation);
